/*
 * @Author: lubiwei
 * @LastEditors: wangshengqiang
 * @Description: 代理人告知，华润经代项目接入横琴传世一号时追加的组件
 */
import React, { useState, useEffect } from 'react';
import { Button, Checkbox, Toast } from 'zarm';
import { connect } from 'react-redux';
import { dispatch, getState, useStore } from '@/store';
import { SignArea } from '@/baseComponents';
import { getQueryParam } from '@/utils/tool';
import { queryDefaultNoticeQuestionV2, queryPromptPis } from '@/services/questionnaire';
import Questions from './components/questions';
import NavBarWithAirSignature from '../NavBarWithAirSignature';
import './index.less';

const AgentNotifyForHengQin = ({
  agentList
}) => {
  // const orderDetail = getState('orderDetail');
  // const { goodsId, planId, orderNo } = orderDetail || {};
  const planId = useStore('PLAN_ID');
  const {
    goodsId,
    orderNo
  } = getQueryParam() || {};
  const [isShowQuestionnaire, setIsShowQuestionnaire] = useState('');
  const [newQuestionList, setNewQuestionList] = useState([]);
  const [agreementList, setAgreementList] = useState([]);

  const closePopUps = val => setIsShowQuestionnaire(val);

  useEffect(() => {
    if (!orderNo || !goodsId || !planId) return;
    queryDefaultNoticeQuestionV2({
      goodsId,
      planId,
      noticeType: 'insureNotice',
      noticeObjectType: 'agent'
    }).then(res => {
      const {
        result: {
          detailList
        },
        success
      } = res;
      if (!success) return Toast.show('代理人问卷获取异常!');
      if (!(detailList !== null && detailList !== void 0 && detailList.length)) return Toast.show('问卷数据异常!');
      dispatch({
        'questionList.agentList': detailList === null || detailList === void 0 ? void 0 : detailList.map(item => ({
          code: item.code,
          reply: '',
          content: item.content,
          answerList: item.questionList.map(r => {
            return {
              index: r.index,
              value: '' // isRequired: true,

            };
          })
        }))
      });
      detailList.forEach(item => {
        item.questionList.forEach(changeItem => {
          var _changeItem$options;

          (changeItem === null || changeItem === void 0 ? void 0 : (_changeItem$options = changeItem.options) === null || _changeItem$options === void 0 ? void 0 : _changeItem$options.length) && changeItem.options.forEach(changeContent => {
            if ((changeContent === null || changeContent === void 0 ? void 0 : changeContent.relation) > 0) {
              item.questionList.forEach(r => {
                if (r.index === changeContent.relation) {
                  r.isShow = false;
                  r.isDefault = true;
                }
              });
            }
          });
        });
      });
      setNewQuestionList(detailList);
    }).catch(err => {
      Toast.show(err || '服务异常'); // console.error(err || '网络阻塞，请稍等');
    });
    queryPromptPis({
      orderNo,
      // signType: 0-投保人签名 1-投保人人脸识别或拍照 2-被保人/监护人签名 3-被保人拍照 4-代理人签名 5-销售人员签名
      signType: '4'
    }).then(res => {
      var _result$promptBookLis;

      const {
        success,
        result
      } = res;
      if (!success) return Toast.show('代理人签名文件获取异常!');
      if (!(result !== null && result !== void 0 && (_result$promptBookLis = result.promptBookList) !== null && _result$promptBookLis !== void 0 && _result$promptBookLis.length)) return Toast.show('问卷数据异常!');
      setAgreementList((result === null || result === void 0 ? void 0 : result.promptBookList) || []);
    }).catch(err => {
      Toast.show(err || '服务异常!'); // console.error(err || '网络阻塞，请稍等');
    });
  }, [goodsId, planId, orderNo]);
  return /*#__PURE__*/React.createElement("div", {
    className: "AgentNotifyForHengQin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "informQuestionnaire"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "topContent"
  }, /*#__PURE__*/React.createElement("p", null, "\u6295\u4FDD\u4EBA\u5E94\u5728\u5BF9\u6240\u6709\u88AB\u4FDD\u9669\u4EBA\u5065\u5EB7/\u804C\u4E1A\u72B6\u51B5\u5145\u5206\u4E86\u89E3\u7684\u57FA\u7840\u4E0A\u5C65\u884C\u5982\u5B9E\u544A\u77E5\u4E49\u52A1\u3002\u6295\u4FDD\u4EBA\u627F\u8BFA\u5B8C\u5168\u77E5\u6653\u6240\u6709\u88AB\u4FDD\u9669\u4EBA\u5065\u5EB7/\u804C\u4E1A\u72B6\u6001\u3002")), /*#__PURE__*/React.createElement("div", {
    className: "bottomContent"
  }, /*#__PURE__*/React.createElement("p", {
    className: "contentTips"
  }, "\u82E5\u88AB\u4FDD\u9669\u4EBA\u5065\u5EB7/\u804C\u4E1A\u72B6\u51B5\u4E0E\u4E0B\u8FF0\u544A\u77E5\u5185\u5BB9\u4E0D\u7B26\uFF1A"), /*#__PURE__*/React.createElement("p", null, "(1) \u672C\u516C\u53F8\u6709\u6743\u4E0D\u540C\u610F\u627F\u4FDD\u3002"), /*#__PURE__*/React.createElement("p", null, "(2) \u82E5\u53D1\u751F\u4FDD\u9669\u4E8B\u6545\uFF0C\u672C\u516C\u53F8\u4E0D\u627F\u62C5\u8D54\u507F\u6216\u7ED9\u4ED8\u4FDD\u9669\u91D1\u7684\u8D23\u4EFB\uFF0C\u5E76\u6709\u6743\u4E0D\u9000\u8FD8\u4FDD\u8D39\u3002")))), /*#__PURE__*/React.createElement("div", {
    className: "agentInformed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inform"
  }, /*#__PURE__*/React.createElement("p", {
    className: "checkBox"
  }, "\u300A\u4EE3\u7406\u4EBA\u544A\u77E5\u300B"), !isShowQuestionnaire ? /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    size: "xs",
    onClick: () => setIsShowQuestionnaire('isOpen')
  }, "\u586B\u5199") : /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#BCBCBC',
      fontSize: '15px',
      marginRight: '10px'
    }
  }, "\u5DF2\u5B8C\u6210")), isShowQuestionnaire === 'isOpen' && /*#__PURE__*/React.createElement(Questions, {
    closePopUps: closePopUps,
    questionList: newQuestionList,
    agentList: agentList
  })), /*#__PURE__*/React.createElement("div", {
    className: "signature"
  }, /*#__PURE__*/React.createElement(SignArea, {
    onChange: url => dispatch('agent.agentSignUrl', url)
  })), /*#__PURE__*/React.createElement("div", {
    className: "agreementBox"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: "agreement"
  }), /*#__PURE__*/React.createElement("p", null, "\u60A8\u7684\u7B7E\u540D\u5C06\u88AB\u7528\u4E8E", agreementList.map(item => {
    return /*#__PURE__*/React.createElement("span", {
      key: item.location,
      className: "checkLink",
      onClick: () => {
        if (item !== null && item !== void 0 && item.location) return Toast.show('该投保提示书链接异常');
        dispatch({
          isShowPdfViewer: true,
          pdfUrl: item.location
        });
      }
    }, "\u300A", (item === null || item === void 0 ? void 0 : item.describe) || '投保提示书', "\u300B");
  }), "\u6587\u4EF6")), /*#__PURE__*/React.createElement("div", {
    className: "footer-button"
  }, /*#__PURE__*/React.createElement(NavBarWithAirSignature, null))));
};

export default connect(state => {
  return {
    agentList: state.questionList.agentList
  };
})(AgentNotifyForHengQin);